import { create } from 'zustand';

const EMPTY_COMMISSION = {
  type: 'percentage',
  defaultRate: 0,
  perServiceRates: {},
};

const EMPTY_FORM = {
  name: '',
  surname: '',
  emailAddress: '',
  phone: { countryCode: '+90', number: '' },
  role: 'employee',
  status: 'active',
  commissionConfig: null, // null = prim tanımlanmamış
};

/**
 * employees feature UI state.
 * Firestore verisi burada YAŞAMAZ — yalnızca searchTerm, modal ve form taslağı.
 */
const useEmployeesStore = create((set) => ({
  // ── Arama ──────────────────────────────────────────────────
  searchTerm: '',
  setSearchTerm: (term) => set({ searchTerm: term }),

  // ── Modal ──────────────────────────────────────────────────
  isModalOpen: false,
  isEditing:   false,
  editingId:   null,
  formData:    EMPTY_FORM,

  /** Yeni kayıt için: openModal() | Düzenleme için: openModal(employee) */
  openModal: (employee = null) =>
    set(
      employee
        ? {
            isModalOpen: true,
            isEditing:   true,
            editingId:   employee.id,
            formData: { ...EMPTY_FORM, ...employee },
          }
        : {
            isModalOpen: true,
            isEditing:   false,
            editingId:   null,
            formData:    EMPTY_FORM,
          }
    ),

  closeModal: () =>
    set({ isModalOpen: false, isEditing: false, editingId: null, formData: EMPTY_FORM }),

  /** Tek bir form alanını günceller. */
  updateFormField: (field, value) =>
    set((s) => ({ formData: { ...s.formData, [field]: value } })),

  /** commissionConfig'i başlatır veya tamamen kaldırır. */
  enableCommission:  () =>
    set((s) => ({ formData: { ...s.formData, commissionConfig: { ...EMPTY_COMMISSION } } })),
  disableCommission: () =>
    set((s) => ({ formData: { ...s.formData, commissionConfig: null } })),

  /** commissionConfig içindeki tek bir alanı günceller. */
  updateCommissionField: (field, value) =>
    set((s) => ({
      formData: {
        ...s.formData,
        commissionConfig: { ...(s.formData.commissionConfig || EMPTY_COMMISSION), [field]: value },
      },
    })),

  /** Hizmet bazlı oran ekler/günceller. */
  setPerServiceRate: (serviceId, rate) =>
    set((s) => {
      const cfg = s.formData.commissionConfig || EMPTY_COMMISSION;
      return {
        formData: {
          ...s.formData,
          commissionConfig: {
            ...cfg,
            perServiceRates: { ...cfg.perServiceRates, [serviceId]: rate },
          },
        },
      };
    }),

  /** Hizmet bazlı oranı kaldırır. */
  removePerServiceRate: (serviceId) =>
    set((s) => {
      const cfg = s.formData.commissionConfig || EMPTY_COMMISSION;
      const { [serviceId]: _, ...rest } = cfg.perServiceRates || {};
      return {
        formData: {
          ...s.formData,
          commissionConfig: { ...cfg, perServiceRates: rest },
        },
      };
    }),
}));

export default useEmployeesStore;
